import { Button, ButtonIcon, Content, Root } from './Styles';
import React, { Component } from 'react';

import Icon from '../Icon';
import IconSVG from '../Icon/IconSVG';
import PropTypes from 'prop-types';
import color from '../../theme/color';
import { translate } from 'react-i18next';

class ShowMoreText extends Component {
  state = {
    isActive: false
  };

  updateStatus = () => {
    this.setState({
      isActive: !this.state.isActive
    });
  };

  render() {
    const { children, t } = this.props;

    return (
      <Root>
        <Content
          ref={ref => (this.Content = ref)}
          isActive={this.state.isActive}
        >
          {children}
        </Content>
        <Button onClick={this.updateStatus}>
          <IconSVG mr={6} name={this.state.isActive ? 'minus' : 'plus'} />
          {this.state.isActive ? t('others.see_less') : t('others.see_more')}
        </Button>
      </Root>
    );
  }
}

ShowMoreText.propTypes = {
  children: PropTypes.any.isRequired,
  t: PropTypes.func
};

export default translate()(ShowMoreText);
